// extracted by mini-css-extract-plugin
module.exports = {"Main":"OffSiteHistoryItem_Main__t40si","Item":"OffSiteHistoryItem_Item__EjNVq","Value":"OffSiteHistoryItem_Value__Ubkkv"};